import {useEffect, useState} from "react";
import {HideMainLoading, HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import '../../../static/css/pages/print/print.css';
import {tuitionPaymentInterface} from "../finance/tuition-payments";
import {useParams} from "react-router-dom";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ShowConnectionFailed} from "../../../components/template/connection-failed";
import {CurrencyFormat, StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {GregorianToPersian} from "../../../components/techaran/date-convert";
import {TomansIcon} from "../../../components/icons/material-icons";
import {thoseWhoPaidInFull} from "../finance/fully-paid";
import {GradeToString} from "../students/list";

export const AdminsPrintThoseWhoStillOwe = () => {
    const [data,setData] = useState({
        loaded:false,
        list:[] as thoseWhoPaidInFull[],
    });
    const {classId} = useParams();
    const fetchList = () => {
        const _classId = classId as string;
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/finance/who-owe/list',
            {
                classId:_classId,
            },
            true,
            (d: {
                result:string,
                reason:string|undefined,
                list:thoseWhoPaidInFull[] | null,
            })=>{
                HideProgressLoading();
                if(d.result !== 'OK'){
                    if(d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setData({
                    list: d.list === null ? [] : d.list,
                    loaded: true,
                });
            },
            ()=>{
                HideProgressLoading();
                ShowConnectionFailed('fa');
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        document.title = "پرینت بدهکاران | نهال";
        HideMainLoading();
        fetchList();
    }, []);
    return (
        <>
            <div className="print-screen">
                <button onClick={window.print}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
                        <path
                            d="M640-615.385v-120H320v120h-40v-160h400v160h-40Zm-456.923 40h593.846-593.846Zm521.538 100q17 0 28.5-11.5t11.5-28.5q0-17-11.5-28.5t-28.5-11.5q-17 0-28.5 11.5t-11.5 28.5q0 17 11.5 28.5t28.5 11.5ZM640-200v-181.538H320V-200h320Zm40 40H280v-160H143.077v-215.385q0-34 23.077-57t56.923-23h513.846q34 0 57 23t23 57V-320H680v160Zm96.923-200v-175.385q0-17-11.5-28.5t-28.5-11.5H223.077q-17 0-28.5 11.5t-11.5 28.5V-360H280v-61.539h400V-360h96.923Z"/>
                    </svg>
                    پرینت
                </button>
                <b>فهرست دانش‌آموزان بدهکار شهریه</b>
                <span>دبستان مهارتی نهال</span>
                <table className="table open-table table-stripped table-bordered"
                       style={{display: 'table!important', border: 0}}>
                    <thead>
                    <tr>
                        <th>ردیف</th>
                        <th>دانش‌آموز</th>
                        {/*<th>کدملی</th>*/}
                        <th>کلاس</th>
                        <th>مبلغ شهریه</th>
                        <th>مبلغ پرداختی</th>
                        <th>مبلغ بدهی</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        (data.list === null ? [] : data.list).map((p, i) =>
                            <tr key={"K39Erc1nxS" + i}>
                                <td>{StringDigitsConvertToPersian(i + 1)}</td>
                                <td>{p.name}</td>
                                {/*<td style={{width: '15%'}}>{StringDigitsConvertToPersian(p.nationalCode)}</td>*/}
                                <td>{p.class === '' ? 'نامشخص' : p.class}</td>
                                <td>
                                    <span>{CurrencyFormat(p.totalTuitionPrice)}<TomansIcon/></span>
                                </td>
                                <td>
                                    <span>{CurrencyFormat(p.paidAmount)}<TomansIcon/></span>
                                </td>
                                <td>
                                    <span>{CurrencyFormat(p.totalTuitionPrice - p.paidAmount)}<TomansIcon/></span>
                                </td>
                            </tr>
                        )
                    }
                    </tbody>
                </table>
            </div>
        </>
    );
};